import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import Modal from 'react-modal';
import { ThemeProvider } from 'styled-components';
import { theme as lowRiskTheme } from '@d24/ui-lib';
import config from './envConfig/config';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';
import i18n, { locale } from './config/i18n';
import './styles/index.scss';

import { GlobalStyle } from './envConfig/styledComponents';
import { initializeMonitoring } from './utils/Monitoring';

Modal.setAppElement('#root');
const panelTheme = config.REACT_APP_THEME;
const logoUrls = config.REACT_APP_LOGO_URL;
document.title = config.REACT_APP_SITE_TITLE;

// TODO: Remove when the poc is done
initializeMonitoring();

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <IntlProvider locale={locale}>
      <ThemeProvider theme={{ ...panelTheme, ...lowRiskTheme, ...logoUrls }}>
        <GlobalStyle />
        <Provider store={store}>
          <ErrorBoundary>{<App />}</ErrorBoundary>
        </Provider>
      </ThemeProvider>
    </IntlProvider>
  </I18nextProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
